export var RedemptionStatus;
(function (RedemptionStatus) {
    RedemptionStatus["Pending"] = "pending";
    RedemptionStatus["Disbursed"] = "disbursed";
})(RedemptionStatus || (RedemptionStatus = {}));
//# sourceMappingURL=insurance-funds.js.map